import { WprBaseViewCore } from '../WprBaseViewCore';
import { WprFramework } from '../../WprFramework';
import { WprBaseDIManage } from './WprBaseDIManage';

/**
 * グローバルスコープモデルDIデコレータ
 * @param modelName モデル名称
 */
export function WprDI_GlobalScopeModel(/* target: any, props: string,*/ modelName?: string) {
	WprBaseDIManage.gmodelNameList.push(modelName);
	// return <TFunc extends Function> (target: any, props: string) => {
	return (target: any, props: string) => {
		const diManage = target as WprBaseDIManage;
		if (diManage)
			WprFramework.getInstance().model.addDecoMapInfo('GlobalScopeModel', diManage, WprBaseViewCore.gmodelNameList.shift(), props);
	};
}
